import React from "react";
import { Button, Modal } from "@mantine/core";
import { Eye, FileDownload } from "tabler-icons-react";

export interface DownloadAlertProps {
  renderType?: string;
  reportName?: string;
  Base64File?: string;
  modalOpen: boolean;
  onModalClose: () => void;
  url?: string | null;
}

export function DownloadAlert({
  renderType,
  reportName,
  Base64File,
  modalOpen,
  onModalClose,
  url,
}: DownloadAlertProps) {
  const linkSource = Base64File ? `data:application/${renderType || "pdf"};base64,${Base64File}` : "";
  const fileName = Base64File ? `report_${reportName || "export"}.${renderType || "pdf"}` : "";

  const b64toBlob = (base64: string, type: string = "application/pdf"): Promise<Blob> =>
    fetch(`data:${type};base64,${base64}`).then((res) => res.blob());

  const handleView = async () => {
    if (!Base64File) return;
    try {
      const blob = await b64toBlob(Base64File, `application/${renderType || "pdf"}`);
      const fileURL = URL.createObjectURL(blob);
      window.open(fileURL, "_blank");
    } catch (error) {
      alert("Could not open PDF - please use any device except iPhone.");
    }
  };

  return (
    <>
      <Modal
        opened={modalOpen}
        onClose={() => onModalClose()}
        centered
        title="Report ready"
      >
        <div style={{ display: "flex", justifyContent: "space-around" }}>
          {url ? (
            <>
              <a href={url} target="_blank" rel="noreferrer">
                <Button
                  leftIcon={<FileDownload size={18} />}
                  color="cap-navy"
                  style={{ width: "150px" }}
                >
                  Download
                </Button>
              </a>
            </>
          ) : (
            <>
              {renderType === "pdf" && (
                <Button
                  leftIcon={<Eye size={18} />}
                  onClick={handleView}
                  color="cap-navy"
                  style={{ width: "150px" }}
                >
                  View
                </Button>
              )}
              <a href={linkSource} download={fileName}>
                <Button
                  leftIcon={<FileDownload size={18} />}
                  color="cap-navy"
                  style={{ width: "150px" }}
                >
                  Download
                </Button>
              </a>
            </>
          )}
        </div>
      </Modal>
    </>
  );
}

export default DownloadAlert;

